<app-content-header (backEvent)="onBack()" [historyBack]="historyBack" [backLabel]="backLabel" [headline]="'invoice_headline' | i18next"></app-content-header>

<div class="card card-nb">
  <div class="card-body">
      <app-company-form [company]="company"
                        [countries]="countries"
                        [isCountryChangeable]="false"
                        [showElectronicInvoiceMail]="false"
                        submitButtonLabel="app_next"
                        (formSubmit)="onNext($event)">
      </app-company-form>
  </div>
</div>
